<template>
  <el-dialog ref="dialog" title="页面布局" size="large" style="min-width:1280px">
    <div v-if="showConfig">
      <el-select v-model="nodeValue" placeholder="请选择复制的节点" class="m-b-10">
        <el-option
          v-for="item in modifyNode"
          :label="item.name"
          :value="item">
        </el-option>
      </el-select>
      <el-button type="success" @click="copy">复制</el-button>
    </div>
    <div>
      <div class="m-b-10">
        <el-button @click="addFieldGroup">添加分组</el-button>
      </div>
      <div 
        class="input-list bor-deep-gra ovf-auto m-b-20" 
        style="width:100%;height:500px" 
        @mouseover="showInsertPos($event, -1)" 
        @mouseup="sortGroupUp($event)">
        <div 
          v-for="(item, index) in fieldGroup" 
          class="bor-b-ccc" 
          :class="{'temp-group': item.temp}" 
          @mouseenter="showInsertPos($event, index)" 
          v-show="!item.hide">
          <div v-if="!item.temp">
            <div class="bor-b-gray">
              <div class="inline-block drag-shank" size="small" type="danger" @mousedown="sortGroupDown($event, item, index)">
                <i class="fa fa-arrows fz-24 c-blue"></i>
              </div>
              <div class="inline-block m-r-10">
                <el-button type="primary" size="small" @click="groupUp(index)" :disabled="index == 0">上移</el-button>
                <el-button type="primary" size="small" @click="groupDown(index)" :disabled="index == fieldGroup.length - 1">下移</el-button>
              </div>
              <el-input class="w-200 m-r-10" v-model="item.group" placeholder="分组名称"></el-input>
              <div class="inline-block m-r-20">
                <span>布局：</span>
                <el-radio-group v-model="item.layout">
                  <el-radio :label="10">一列</el-radio>
                  <el-radio :label="20">两列</el-radio>
                  <el-radio :label="30">三列</el-radio>
                  <el-radio :label="40">四列</el-radio>
                </el-radio-group>
              </div>
              <div class="fr">
                <el-button type="primary" size="small" @click="showConditionListDialog(item)" v-show="needCondition">可见条件</el-button>
                <el-button type="danger" size="small" @click="showDeleteConfirmDialog(index)">删除分组</el-button>
                <el-button size="small" @click="showInputListDialog(item)">配置控件</el-button>
                <el-button type="primary" size="small" @click="saveOneGroup(item)">保存修改</el-button>
              </div>
            </div>
            <input-group :field="item.inputs" :inputType="inputType" :inputTitle="inputTitle" :layout="item.layout" v-show="!isSort"></input-group>
          </div>
        </div>
        <!-- 排序标签 -->
        <div class="pos-fixed sort-group" v-if="isSort" :style="styleObject">
          <div class="bor-b-gray">
            <div class="inline-block drag-shank" size="small" type="danger">
              <i class="fa fa-arrows fz-24 c-blue"></i>
            </div>
            <div class="inline-block m-r-10">
              <el-button type="primary" size="small" :disabled="index == 0">上移</el-button>
              <el-button type="primary" size="small" :disabled="index == fieldGroup.length - 1">下移</el-button>
            </div>
            <el-input class="w-200 m-r-10" v-model="curGroup.group" placeholder="分组名称"></el-input>

            <div class="inline-block m-r-20">
              <span>布局：</span>
              <el-radio-group v-model="curGroup.layout">
                <el-radio :label="10">一列</el-radio>
                <el-radio :label="20">两列</el-radio>
                <el-radio :label="30">三列</el-radio>
              </el-radio-group>
            </div>
            <div class="fr">
              <el-button size="small">配置控件</el-button>
              <el-button type="primary" size="small">保存修改</el-button>
            </div>
          </div>
        </div>
        <!-- 排序标签 -->
      </div>
      <div style="clear:both"></div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelSetInput">取 消</el-button>
        <el-button type="primary" @click="confirmSetInput">保存所有修改</el-button>
      </span>
    </div>
  </el-dialog>
</template>

<style>
  .el-dialog__body{
    padding:10px 20px;
  }
  .sort-group {
    width: 1000px;
    background-color: #fff;
    z-index: -1;
  }
  .temp-group {
    height: 100px !important;
    border: 1px dashed black;
  }
</style>

<script>
  import inputGroup from './inputGroup'
  export default {
    props: {
      inputTitle: { // 控件字段标题数组
        type: Array,
        default() {
          return []
        }
      },
      inputType: {  // 控件类型数组
        type: Array,
        default() {
          return []
        }
      },
      curGroupIds: {  // 当前分组id
        type: Array,
        default() {
          return []
        }
      },
      conditionLists: { // 分组可见条件数组
        type: Array,
        default() {
          return []
        }
      },
      modifyNode: {
        type: Array,
        default() {
          return []
        }
      },
      needCondition: {  // 需要配置分组可见条件
        type: Boolean,
        default() {
          return true
        }
      },
      needDefault: {  // 需要默认传值
        type: Boolean,
        default() {
          return false
        }
      },
      isFullInputData: {  // 是否返回控件的全部数据
        type: Boolean,
        default() {
          return true
        }
      },
      showConfig: {
        type: Boolean
      }
    },
    data() {
      return {
        curField: [], // 当前节点的控件临时数组
        tempConditionList: [], // 分组可见条件数组
        fieldGroup: [], // 控件分组
        isSort: false,
        curGroup: {},
        tempGroup: {},
        conditionGroup: {}, // 可见条件分组
        styleObject: {
          left: 0,
          top: 0
        },
        count: -1,
        deleteGroupIndex: null,
        nodeValue: []
      }
    },
    created() {
      this.init()
    },
    methods: {
      init() {
        document.addEventListener('mouseup', () => {
          // 控件拖拽、控件排序取消
          this.isSort = false
          if (this.insertPos != null) {
            delete this.curGroup.hide
            this.insertPos = null
          }
        })
        document.addEventListener('mousemove', (event) => {
          this.sortGroupMove(event)
        })
        this.tempConditionList = this.conditionLists
      },
      sortGroupDown(event, item, index) {
        this.curGroup = item
        item.hide = true
        this.isSort = true
        this.styleObject = {
          left: event.pageX - 120 + 'px',
          top: event.pageY - 180 + 'px'
        }
      },
      sortGroupMove(event) {
        if (!this.isSort) {
          return
        }
        let left = event.pageX - 120 + 'px'
        let top = event.pageY - 180 + 'px'
        this.styleObject = {
          left: left,
          top: top
        }
      },
      sortGroupUp(event) {
        if (!this.isSort) {
          return
        }
        if (this.insertPos != null) {
          delete this.curGroup.hide
          let sourceIndex = _.indexOf(this.fieldGroup, this.curGroup)
          this.fieldGroup.splice(this.insertPos, 1, this.curGroup)
          this.fieldGroup.splice(sourceIndex, 1)
        }
        this.curGroup = {}
        this.isSort = false
      },
      // 显示插入的位置
      showInsertPos(event, index) {
        event.stopPropagation()
        if (!this.isSort) {
          return
        }
        let tempGroup = {
          temp: true
        }
        if (this.insertPos != null) {
          this.fieldGroup.splice(this.insertPos, 1)
        }
        this.insertPos = index != -1 ? index : this.fieldGroup.length
        this.fieldGroup.splice(this.insertPos, 0, tempGroup)
      },
      // 确定关联控件修改
      confirmSetInput() {
        // let ok = true
        let newGroupInput = []
        _(this.fieldGroup).forEach((item) => {
          // if (!item.group && item.inputs && item.inputs) {
          //   ok = false
          //   return
          // }
          _(item.inputs).forEach((res) => {
            let input = {
              field_id: res.field_id, // 控件id
              field_auth: res.field_auth, // 控件权限
              sort: res.sort, // 控件排序
              group: item.group,  // 分组名
              layout: item.layout,  // 布局，10一列20两列30三列40四列
              field_default: res.field_default,  // 默认传值
              group_id: item.group_id,   // 分组唯一标志
              key_major: res.key_major,  // 主字段（外键才有值）
              key_depent: res.key_depent, // 从属字段（外键才有值）
              way: res.way, // 默认值选择方式
              logic_condition: res.logic_condition, // 字段对应逻辑条件
              option_relation: res.option_relation, // 下拉/单选/复选
              people_filter: res.people_filter, // 人员控件条件配置
              struct_filter: res.struct_filter, // 部门控件条件配置
              key_filter: res.key_filter,
              key_fillin: res.key_fillin, // 外键连带获取
              key_cascade: res.key_cascade // 外键级联
            }
            if (this.isFullInputData) {
              input.name = res.name // 控件字段名
              input.title = res.title // 控件字段标题
              input.status = item.status  // 分组条件是否开启，1开启0关闭
              input.index = item.index  // 分组索引值
              input.type = res.type // 控件类型
            }
            newGroupInput.push(input)
          })
        })
        // if (!ok) {
        //   _g.toastMsg(this, 'error', '请确保所有分组都有命名')
        //   return
        // }
        this.$emit('confirmCurField', newGroupInput)
        this.curField = []
        _g.toastMsg(this, 'success', '保存成功！')
        this.closeDialog()
        this.nodeValue = []
      },
      // 关闭控件选择
      cancelSetInput() {
        this.curField = []
        this.closeDialog()
      },
      setCurField(field) {
        this.curField = field
        this.createFieldGroup()
      },
      // 创建控件分组
      createFieldGroup() {
        this.fieldGroup = []
        this.count = -1
        let curGroupId = 0
        _(this.curField).forEach((res) => {
          if (!curGroupId || curGroupId != res.group_id) {
            curGroupId = res.group_id
            this.count++
            let field = {
              group: res.group,
              group_id: res.group_id,
              status: res.status,
              layout: res.layout ? res.layout : 10,
              inputs: [],
              index: this.count
            }
            this.fieldGroup.push(field)
          }
          res.index = this.count
          this.fieldGroup[this.count].inputs.push(res)
        })
        this.nodeValue = []
      },
      // 复制节点信息
      copy() {
        this.curField = this.nodeValue.field
        this.createFieldGroup()
      },
      addFieldGroup() {
        let newGroupId = 1
        let tempCurGroupIds = this.curGroupIds
        if (this.curGroupIds.length != 0) {
          _(this.curGroupIds).forEach((res, index) => {
            let next = index + 1
            if (this.curGroupIds.length == 1) {
              // 只有一个id
              if (newGroupId < res) {
                newGroupId = res - 1
              } else {
                newGroupId = res + 1
              }
              return
            }
            if (next < this.curGroupIds.length) {
              if (this.curGroupIds[next] - this.curGroupIds[index] > 1) {
                newGroupId = this.curGroupIds[index] + 1
                return
              }
            } else {
              newGroupId = this.curGroupIds[index] + 1
            }
          })
        }
        tempCurGroupIds.push(newGroupId)
        this.tempConditionList.push({
          group_id: newGroupId,
          group_name: '',
          status: 0,
          condition: []
        })
        this.$emit('setCurGroupIds', tempCurGroupIds)
        let field = {
          group: '',
          group_id: newGroupId,
          status: 0,
          layout: 10,
          inputs: [],
          index: ++this.count
        }
        this.fieldGroup.push(field)
      },
      saveOneGroup(item) {
        // 思路：先挖空当前分组的所有控件，再从原先的位置插入新的数组
        // if (!item.group && item.inputs && item.inputs.length) {
        //   _g.toastMsg(this, 'error', '请为分组命名')
        //   return
        // }
        let newGroupInput = []
        _(item.inputs).forEach((res) => {
          let input = {
            field_id: res.field_id, // 控件id
            field_auth: res.field_auth, // 控件权限
            sort: res.sort, // 控件排序
            group: item.group,  // 分组名
            group_id: item.group_id,   // 分组唯一标志
            layout: item.layout,  // 布局，10一列20两列30三列40四列
            field_default: res.field_default,  // 默认传值
            key_major: res.key_major,  // 主字段（外键才有值）
            key_depent: res.key_depent, // 从属字段（外键才有值）
            way: res.way, // 默认值选择方式
            logic_condition: res.logic_condition, // 字段对应逻辑条件
            option_relation: res.option_relation, // 下拉/单选/复选
            people_filter: res.people_filter, // 人员控件条件配置
            struct_filter: res.struct_filter, // 部门控件条件配置
            key_filter: res.key_filter, // 筛选条件
            key_fillin: res.key_fillin, // 外键连带获取
            key_cascade: res.key_cascade // 外键级联
          }
          if (this.isFullInputData) {
            input.name = res.name // 控件字段名
            input.title = res.title // 控件字段标题
            input.status = item.status  // 分组条件是否开启，1开启0关闭
            input.index = item.index  // 分组索引值
            input.type = res.type // 控件类型
          }
          newGroupInput.push(input)
        })
        let firstKey = -1
        _.remove(this.curField, (res, key) => {
          if (firstKey == -1 && res.index == item.index) {
            firstKey = key
          }
          return res.index == item.index
        })
        if (firstKey == -1) {
          firstKey = 0
        }
        let frontArr = this.curField.slice(0, firstKey)
        let endArr = this.curField.slice(firstKey, this.curField.length)
        this.curField = [...frontArr, ...newGroupInput, ...endArr]
        _(this.curField).forEach((res) => {
          delete res.index
        })
        this.$emit('confirmCurField', this.curField)
        _g.toastMsg(this, 'success', '保存修改成功')
      },
      deleteGroup() {
        this.fieldGroup.splice(this.deleteGroupIndex, 1)
        let firstKey = -1
        _.remove(this.curField, (res, key) => {
          return res.index == this.deleteGroupIndex
        })
        _(this.curField).forEach((res) => {
          delete res.index
        })
        // this.$emit('updateConditionList', this.curField[this.deleteGroupIndex]['group'])
        this.$emit('confirmCurField', this.curField)
        _g.toastMsg(this, 'success', '删除分组成功')
        this.deleteGroupIndex = null
      },
      groupUp(index) {
        let temp = this.fieldGroup[index]
        this.fieldGroup.splice(index, 1)
        this.fieldGroup.splice(index - 1, 0, temp)
      },
      groupDown(index) {
        let temp = this.fieldGroup[index]
        this.fieldGroup.splice(index, 1)
        this.fieldGroup.splice(index + 1, 0, temp)
      },
      showConditionListDialog(item) {
        let self = this
        // 兼容旧数据，tempConditionList为空的情况下，默认关闭可见条件
        if (this.tempConditionList.length == 0) {
          self.$emit('setConditionListShow', { item: { condition: [], group_id: item.group_id, group: item.group, status: 0 }, show: true })
        } else {
          _(this.tempConditionList).forEach((val, index) => {
            if (val.group_id == item.group_id) {
              self.$emit('setConditionListShow', { item: val, show: true })
              return
            }
          })
        }
      },
      showInputListDialog(item) {
        this.curGroup = item
        let existFieldIds = []
        _(this.fieldGroup).forEach((group) => {
          if (group.index != this.curGroup.index) {
            _(group.inputs).forEach((res) => {
              existFieldIds.push(res.field_id)
            })
          }
        })
        this.$emit('setInputListShow', true)
        this.$emit('resetTempInputList', item, existFieldIds)
      },
      showDeleteConfirmDialog(index) { // 确认删除分组弹窗
        this.deleteGroupIndex = index
        this.$confirm('确认删除该分组?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.deleteGroup()
        })
        // this.$emit('showDeleteConfirmDialog', true)
      },
      setNewInputList(inputs) {
        this.curGroup.inputs = inputs
      },
      setNewConditionList(condition) {
        _(this.tempConditionList).forEach((val) => {
          if (val.group_id == condition.group_id) {
            val.condition = condition.condition
            val.status = condition.status
            return
          }
        })
      },
      setConditionList(conditions) {
        this.conditionGroup = conditions
        this.$emit('confirmCondition', this.conditionGroup)
      },
      openDialog() {
        this.$refs.dialog.open()
      },
      closeDialog() {
        this.$refs.dialog.close()
      }
    },
    components: {
      inputGroup
    },
    watch: {
      'conditionLists'(val) {
        this.tempConditionList = val
      }
    }
  }
</script>


// WEBPACK FOOTER //
// inputConfig.vue?0354834d